<template>
  <div
    class="notification font-semibold"
    :class="type"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Notice',

  props: {
    type: {
      type: String,
      default: 'is-danger',
    },
  },
};
</script>
